import React, { useState } from 'react';
import { Card, CardBody, CardFooter, Col, Input, Label, Row } from 'reactstrap';

import { LoadLogoHeader } from '../../../../Layouts/LoadLogo';
import background_image from "../../../../assets/images/small/img-4.jpg";

const SectionImagePage = ({ elements, page, handleDynamicChange, edit, period }) => {
    const title = elements.length > 0 ? elements[0].title : '';
    const img = elements.length > 0 ? elements[0].image : null;
    const [image, setImage] = useState(img);

    const handleFileChange = (event) => {
        const file = event.currentTarget.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setImage(base64String);
                handleDynamicChange(0, 'image', base64String); // Envía la imagen en formato base64
            };
            reader.readAsDataURL(file); // Convierte el archivo en base64
        }
    };

    return (

        <Row>
            {edit && (
                <Col lg={12}>
                    <Label for="document_evidence">
                        Subir imagen de fondo
                    </Label>
                    <Input
                        id="document_evidence"
                        name="document_evidence"
                        type="file"
                        onChange={handleFileChange}
                    />
                </Col>
            )}

            <Col lg={8} className='p-2'>
                <Card className="card-overlay border card-border-primary">
                    <img className="card-img img-fluid" src={image || background_image} alt="Card" />
                    <div className="card-img-overlay p-0 d-flex flex-column">
                        <CardBody style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center' }}>
                            <div style={{ flex: '0 1 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                <p className="fs-1 text-white fw-bold">Cooke Aquaculture Chile</p>
                            </div>

                            <div className='text-center' style={{ flex: '0 1 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', margin: '10px 0' }}>
                                <Row className='w-100'>
                                    <Col md={4}></Col>
                                    <Col md={4}>
                                        <Input
                                            name='title'
                                            id='title'
                                            className='form-control w-100'
                                            placeholder='Ingrese un título de la portada'
                                            type='text'
                                            value={title}
                                            onChange={(e) => handleDynamicChange(0, 'title', e.target.value, page)}
                                        />
                                    </Col>
                                    <Col md={4}></Col>
                                </Row>
                            </div>

                            <div style={{ flex: '0 1 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                <p className="fs-1 text-white fw-bold">{period}</p>
                            </div>
                        </CardBody>



                        <CardFooter className='bg-primary text-white'>
                            <Row>
                                <Col lg={3}>
                                    <LoadLogoHeader maxHeight={40} maxWidth={'300px'} />
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </CardFooter>
                    </div>
                </Card>
            </Col>
        </Row>
    );
};

export default SectionImagePage;

